/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./EditStudent.vue?vue&type=template&id=779d448e&scoped=true&"
import script from "./EditStudent.vue?vue&type=script&lang=js&"
export * from "./EditStudent.vue?vue&type=script&lang=js&"
import style0 from "./EditStudent.vue?vue&type=style&index=0&id=779d448e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779d448e",
  null
  
)

export default component.exports